enum applicationRecipientType {
  Customer = 1,
  Internal = 2,
  External = 3,
}

//other enums

export { applicationRecipientType };
